import { createSlice } from '@reduxjs/toolkit';

import { createBox, downloadShipmentFile, getSupplyOrders, updateProductionStatus } from '../../apis';

export const ShipmentUnitSlice = createSlice({

    name: 'shipmentUnitPlatform',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        createBoxSuccess: false,
        updateProductionSuccess: false,
        updateProductionSuccessData: {},
        downloadShipmentSuccess: false
    },

    reducers: {
        resetCreateShipmentSuccess: (state, action) => {
          return {
            ...state,
            createBoxSuccess: action.payload
          }
        },
        clearErrorState: (state, action) => {
          return {
            ...state,
            error: action.payload
          }
        },
        clear: (state, action) => {
          return {
            ...state,
            [action.payload.key]: action.payload.value
          }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getSupplyOrders.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getSupplyOrders.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getSupplyOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(createBox.pending, (state, action) => {
            state.isLoading = true;
            state.updateProductionSuccessData = {};
        })
        builder.addCase(createBox.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.createBoxSuccess = true
            state.updateProductionSuccessData = {box_id: action.payload.data?.box_id};
        })
        builder.addCase(createBox.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateProductionStatus.pending, (state, action) => {
            state.isLoading = true;
            state.updateProductionSuccessData = {};
        })
        builder.addCase(updateProductionStatus.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateProductionSuccess = true
            state.updateProductionSuccessData = action.payload.data?.data?.facility_to_quantity_map;
        })
        builder.addCase(updateProductionStatus.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadShipmentFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadShipmentFile.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.downloadShipmentSuccess = true
        })
        builder.addCase(downloadShipmentFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        
        
    }
})

export const { resetCreateShipmentSuccess, clearErrorState, clear } = ShipmentUnitSlice.actions


export default ShipmentUnitSlice.reducer